/* fivetos.js
 * Customer-facing size "5" → "S" on PDP, cart and cart drawer.
 * Blocking head script + MutationObserver so the first paint never shows 5.
 * Input/option values stay "5" so add-to-cart still matches the live variant.
 */
(function () {
  if (window.__fivetosInit) return;
  window.__fivetosInit = true;

  var SKIP_TAGS = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|CODE|PRE|SVG|PATH|MATH)$/;
  var SIZE_NAME = /^(beden|size)$/i;
  var EXACT_FIVE = /^(5|5\.)$/;
  var SIZE_LINE = /^(beden|size)\s*:\s*5\.?\s*$/i;
  var SLASH_FIVE = /\/\s*5\.?\s*$/;

  function shouldSkip(el) {
    if (!el) return true;
    if (el.nodeType === 3) el = el.parentElement;
    if (!el || !el.closest) return true;
    if (SKIP_TAGS.test(el.tagName || '')) return true;
    return Boolean(
      el.closest(
        '.quantity, .quantity__input, [name="quantity"], .price, .money, .unit-price, .cart-item__old-price'
      )
    );
  }

  function optionName(el) {
    var row = el.closest && el.closest('.product-option');
    if (row) {
      var dt = row.querySelector('dt');
      if (dt) return dt.textContent.replace(/:.*/, '').trim();
    }
    var wrap = el.closest && el.closest('[data-size-option], fieldset.product-form__input, .product-form__input');
    if (wrap) {
      var legend = wrap.querySelector('legend, .form__label');
      if (legend) {
        var raw = legend.childNodes[0] ? String(legend.childNodes[0].textContent || legend.textContent) : '';
        return raw.replace(/:.*/, '').trim();
      }
    }
    return '';
  }

  function isSizeContext(el) {
    if (!el || !el.closest) return false;
    if (el.closest('[data-size-option]')) return true;
    if (el.closest('.card-quick-options__option, .card-quick-options__option-label')) return true;
    if (
      el.closest('[data-selected-value]') &&
      el.closest('variant-selects, sticky-add-to-cart, .product-form__input')
    ) {
      return SIZE_NAME.test(optionName(el.closest('fieldset, .product-form__input, variant-selects') || el));
    }
    var name = optionName(el);
    if (name && SIZE_NAME.test(name)) return true;
    return false;
  }

  function rewriteString(value) {
    if (value == null) return value;
    var text = String(value);
    if (text.indexOf('5') === -1) return text;
    var trimmed = text.trim();
    if (EXACT_FIVE.test(trimmed)) return text.replace(/5\.?/, 'S');
    if (SIZE_LINE.test(trimmed)) return text.replace(/(beden|size)(\s*:\s*)5\.?/i, '$1$2S');
    if (SLASH_FIVE.test(trimmed)) return text.replace(/\/\s*5\.?\s*$/, '/ S');
    return text;
  }

  function rewriteTextNode(node) {
    if (!node || node.nodeType !== 3 || !node.nodeValue || node.nodeValue.indexOf('5') === -1) return;
    var parent = node.parentElement;
    if (shouldSkip(parent) || !isSizeContext(parent)) return;
    var next = rewriteString(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function rewriteTree(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      rewriteTextNode(root);
      return;
    }
    if (root.nodeType !== 1 || shouldSkip(root)) return;

    if (root.tagName === 'OPTION' && isSizeContext(root)) {
      var optionText = rewriteString(root.textContent);
      if (optionText !== root.textContent) root.textContent = optionText;
      if (root.dataset && root.dataset.stickyLabel) {
        root.dataset.stickyLabel = rewriteString(root.dataset.stickyLabel);
      }
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var current = walker.nextNode();
    while (current) {
      rewriteTextNode(current);
      current = walker.nextNode();
    }
  }

  function run(root) {
    rewriteTree(root || document.documentElement);
  }

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      var record = records[i];
      if (record.type === 'characterData') {
        rewriteTextNode(record.target);
        continue;
      }
      for (var j = 0; j < record.addedNodes.length; j += 1) {
        rewriteTree(record.addedNodes[j]);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  run(document.documentElement);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  window.fivetos = { run: run };
})();
